/**
 * Fitness / Gym Website — VANTA Athletic
 * Premium black-and-white editorial fitness brand · oversized type,
 * marquees, asymmetric grids, athletic stats. Distinct monochrome theme.
 */

export const FITNESS_GYM_WEBSITE_FILES = {
  'src/index.css': `@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Archivo:wght@400;500;600;700;800;900&family=Archivo+Narrow:wght@500;700&family=JetBrains+Mono:wght@500;700&display=swap');

* { box-sizing: border-box; }
html { scroll-behavior: smooth; }
body {
  margin: 0;
  font-family: 'Archivo', system-ui, sans-serif;
  background: #0A0A0A;
  color: #F5F5F5;
  -webkit-font-smoothing: antialiased;
  font-feature-settings: 'ss01';
}

.vt-display { font-family: 'Bebas Neue', 'Archivo', sans-serif; letter-spacing: 0.005em; line-height: 0.92; }
.vt-condensed { font-family: 'Archivo Narrow', 'Archivo', sans-serif; }
.vt-mono { font-family: 'JetBrains Mono', ui-monospace, monospace; font-feature-settings: 'tnum'; }

@keyframes vt-marquee {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}
@keyframes vt-pulse-line {
  0%, 100% { transform: scaleX(1); opacity: 1; }
  50% { transform: scaleX(0.4); opacity: 0.6; }
}
@keyframes vt-flicker {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.55; }
}

.vt-marquee-track {
  display: inline-flex;
  white-space: nowrap;
  animation: vt-marquee 28s linear infinite;
}
.vt-pulse-bar { transform-origin: left center; animation: vt-pulse-line 1.6s ease-in-out infinite; }

.vt-eyebrow {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.32em;
  text-transform: uppercase;
}
.vt-divider { height: 1px; background: rgba(245, 245, 245, 0.1); }
.vt-divider-light { height: 1px; background: rgba(10, 10, 10, 0.1); }

.vt-btn-fill {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 14px 24px;
  background: #F5F5F5;
  color: #0A0A0A;
  font-weight: 700; font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  border: none; cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Archivo', sans-serif;
}
.vt-btn-fill:hover { background: #FFFFFF; transform: translate(-2px, -2px); box-shadow: 4px 4px 0 0 #F5F5F5; }
.vt-btn-outline {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 14px 24px;
  background: transparent;
  color: #F5F5F5;
  border: 1px solid rgba(245, 245, 245, 0.35);
  font-weight: 700; font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Archivo', sans-serif;
}
.vt-btn-outline:hover { border-color: #F5F5F5; background: rgba(245,245,245,0.05); }

.vt-btn-invert {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 14px 24px;
  background: #0A0A0A;
  color: #F5F5F5;
  font-weight: 700; font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  border: none; cursor: pointer;
  font-family: 'Archivo', sans-serif;
  transition: all 0.3s ease;
}
.vt-btn-invert:hover { background: #1A1A1A; }

.vt-tag {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px;
  border: 1px solid rgba(245, 245, 245, 0.25);
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}
.vt-tag-dark {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px;
  border: 1px solid rgba(10,10,10, 0.2);
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #0A0A0A;
}

.vt-grain {
  position: absolute; inset: 0;
  pointer-events: none;
  opacity: 0.05;
  background-image:
    repeating-linear-gradient(0deg, rgba(255,255,255,0.6) 0 1px, transparent 1px 3px),
    repeating-linear-gradient(90deg, rgba(255,255,255,0.6) 0 1px, transparent 1px 3px);
}

.vt-img-block {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(155deg, rgba(245,245,245,0.06) 0%, rgba(245,245,245,0) 60%),
    linear-gradient(335deg, rgba(245,245,245,0.05) 0%, rgba(10,10,10,1) 70%),
    linear-gradient(180deg, #1A1A1A 0%, #0A0A0A 100%);
}
.vt-img-light {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(155deg, rgba(10,10,10,0.05) 0%, rgba(10,10,10,0) 60%),
    linear-gradient(180deg, #E5E5E5 0%, #B7B7B7 100%);
}

.vt-vertical-label {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  letter-spacing: 0.42em;
  text-transform: uppercase;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: rgba(245,245,245,0.5);
}
`,

  'src/App.js': `import React from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Programs from './components/Programs';
import Trainers from './components/Trainers';
import Transformation from './components/Transformation';
import Membership from './components/Membership';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="relative min-h-screen bg-[#0A0A0A] text-[#F5F5F5]">
      <div className="vt-grain" />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Marquee />
        <Programs />
        <Trainers />
        <Transformation />
        <Membership />
        <Testimonials />
        <Gallery />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}
`,

  'src/data/vanta.js': `export const NAV_LINKS = [
  { label: 'Programs', href: '#programs' },
  { label: 'Coaches', href: '#coaches' },
  { label: 'Membership', href: '#membership' },
  { label: 'Locations', href: '#locations' },
  { label: 'Journal', href: '#journal' },
];

export const HERO_STATS = [
  { value: '14k+', label: 'Active athletes' },
  { value: '320', label: 'Weekly sessions' },
  { value: '42', label: 'Elite coaches' },
  { value: '6', label: 'NYC locations' },
];

export const MARQUEE_ITEMS = [
  'Strength', 'Conditioning', 'Hypertrophy', 'Mobility', 'Combat', 'Olympic Lifts',
  'Endurance', 'Recovery', 'Hyrox', 'Powerlifting', 'Athletic Performance',
];

export const PROGRAMS = [
  {
    code: 'PR-01',
    title: 'Iron Forge',
    sub: 'Strength block · 8 weeks',
    desc: 'Heavy compound work. Progressive overload. Built for athletes chasing absolute strength.',
    tone: 'Intensity 09/10',
    sessions: '5x / week',
    duration: '70 min',
  },
  {
    code: 'PR-02',
    title: 'Velocity',
    sub: 'Conditioning · 6 weeks',
    desc: 'Mixed-modal HIIT and tempo running. Built around output, power, and lactate threshold.',
    tone: 'Intensity 08/10',
    sessions: '4x / week',
    duration: '50 min',
  },
  {
    code: 'PR-03',
    title: 'Hyrox Engine',
    sub: 'Functional racing · 10 weeks',
    desc: 'Run sled, push pull, burpees, wall balls. Race-ready conditioning for elite endurance.',
    tone: 'Intensity 10/10',
    sessions: '5x / week',
    duration: '75 min',
  },
  {
    code: 'PR-04',
    title: 'Combat Athlete',
    sub: 'Striking + S&C · ongoing',
    desc: 'Hybrid combat conditioning. Mitt work, clinch drills, sport-specific strength.',
    tone: 'Intensity 09/10',
    sessions: '4x / week',
    duration: '60 min',
  },
  {
    code: 'PR-05',
    title: 'Mobility Lab',
    sub: 'Recovery · ongoing',
    desc: 'Structured mobility, soft-tissue work, breath. Restoration for the heavy weeks.',
    tone: 'Intensity 04/10',
    sessions: '3x / week',
    duration: '45 min',
  },
  {
    code: 'PR-06',
    title: 'Lift Club',
    sub: 'Powerlifting · 12 weeks',
    desc: 'Squat, bench, deadlift. Periodised meet prep with one-on-one technical coaching.',
    tone: 'Intensity 09/10',
    sessions: '4x / week',
    duration: '85 min',
  },
];

export const TRAINERS = [
  { code: '01', name: 'Marcus Chen', tag: 'Head of Strength', specs: ['Powerlifting', 'Olympic Lifts'], years: 12, athletes: 480, size: 'tall' },
  { code: '02', name: 'Lena Okafor', tag: 'Performance Lead', specs: ['Hyrox', 'Endurance'], years: 9, athletes: 320, size: 'wide' },
  { code: '03', name: 'Diego Marin', tag: 'Combat Coach', specs: ['Striking', 'S&C'], years: 14, athletes: 260, size: 'square' },
  { code: '04', name: 'Anika Sharma', tag: 'Mobility & Recovery', specs: ['Mobility', 'Breath work'], years: 7, athletes: 410, size: 'square' },
];

export const PHASES = [
  { phase: '01', name: 'Assessment', range: 'Week 0', detail: 'Body composition, mobility scan, 1RM testing, conditioning baseline.', pulse: 28 },
  { phase: '02', name: 'Forge', range: 'Week 1 — 4', detail: 'Foundational strength, technique refinement, capacity build. Volume forward.', pulse: 62 },
  { phase: '03', name: 'Sharpen', range: 'Week 5 — 8', detail: 'Intensity climbs. Sport-specific peaking, conditioning blocks, recovery hard-coded.', pulse: 84 },
  { phase: '04', name: 'Express', range: 'Week 9 — 12', detail: 'Peak output, retesting, photo + performance benchmark. The 90 day delivery.', pulse: 100 },
];

export const PLANS = [
  {
    name: 'Core',
    price: '$129',
    period: '/ mo',
    desc: 'Floor access + group classes. Everything you need to begin training with intention.',
    features: ['Unlimited floor access', '8 group classes / month', 'Mobility lab access', 'Locker & towel service'],
    cta: 'Begin',
    featured: false,
  },
  {
    name: 'Pro',
    price: '$249',
    period: '/ mo',
    desc: 'The performance plan. Full programming, semi-private coaching, and recovery.',
    features: ['Unlimited group classes', 'Bi-weekly 1:1 coaching', 'Programmed cycles · 12 weeks', 'Recovery suite + sauna', 'Body composition scans'],
    cta: 'Choose Pro',
    featured: true,
  },
  {
    name: 'Elite',
    price: '$489',
    period: '/ mo',
    desc: 'Bespoke 1-on-1 training with a head coach. For competitive athletes and serious clients.',
    features: ['3x weekly 1:1 sessions', 'Custom periodisation', 'Nutrition coaching', 'Physio + recovery priority', 'Locker · concierge · guest passes'],
    cta: 'Apply',
    featured: false,
  },
];

export const TESTIMONIALS = [
  { quote: 'I came in chasing a number. Eight weeks later my deadlift was up 60 lbs and my back stopped hurting. The coaching is on a different level.', name: 'Sasha L.', meta: 'Pro · 9 months' },
  { quote: 'The Hyrox block is brutal in the best way. Programming is precise, no fluff. I qualified for World Championships training here.', name: 'Idris M.', meta: 'Elite · 2 years' },
  { quote: 'I needed to come back from injury without losing my edge. The mobility lab and 1:1 attention got me stronger than before surgery.', name: 'Mei T.', meta: 'Pro · 14 months' },
];

export const GALLERY = [
  { code: 'F01', label: 'Floor 02 · Strength', size: 'tall' },
  { code: 'F02', label: 'Olympic platform', size: 'square' },
  { code: 'F03', label: 'Recovery suite', size: 'wide' },
  { code: 'F04', label: 'Combat ring', size: 'square' },
  { code: 'F05', label: 'Cardio deck', size: 'wide' },
];

export const FOOTER_COLS = [
  { title: 'Train', links: ['Programs', 'Coaches', 'Schedule', 'Hyrox', 'Combat'] },
  { title: 'Brand', links: ['Story', 'Locations', 'Press', 'Journal', 'Careers'] },
  { title: 'Support', links: ['Member portal', 'FAQ', 'Guest passes', 'Contact'] },
];
`,

  'src/components/Marquee.js': `import React from 'react';
import { MARQUEE_ITEMS } from '../data/vanta';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="relative border-y border-white/10 bg-[#0A0A0A] py-6 overflow-hidden">
      <div className="vt-marquee-track">
        {items.map((m, i) => (
          <span key={i} className="vt-display text-[44px] sm:text-[64px] text-white/90 px-8 inline-flex items-center">
            {m}
            <span className="ml-8 inline-block h-2 w-2 rounded-full bg-white/40" />
          </span>
        ))}
      </div>
    </section>
  );
}
`,

  'src/components/Navbar.js': `import React from 'react';
import { NAV_LINKS } from '../data/vanta';

export default function Navbar() {
  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0A0A0A]/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1380px] items-center justify-between px-6 py-4 md:px-10">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center border border-white/30 text-[#F5F5F5]">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="square" strokeLinejoin="miter">
              <path d="M3 4 12 20 21 4" />
            </svg>
          </span>
          <div className="leading-none">
            <p className="vt-display text-xl font-normal tracking-[0.06em] text-white">VANTA</p>
            <p className="vt-mono mt-1 text-[9px] tracking-[0.32em] text-white/55">ATHLETIC · EST 2018</p>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="vt-mono text-[11px] uppercase tracking-[0.24em] text-white/70 transition hover:text-white">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="#login" className="hidden vt-mono text-[11px] uppercase tracking-[0.22em] text-white/70 transition hover:text-white md:inline">Member sign in</a>
          <button type="button" className="vt-btn-fill">
            Join now
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
          </button>
        </div>
      </div>
    </header>
  );
}
`,

  'src/components/Hero.js': `import React from 'react';
import { HERO_STATS } from '../data/vanta';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-white/10">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-32 top-10 h-[420px] w-[420px] rounded-full bg-white/[0.03] blur-3xl" />
        <div className="absolute -right-40 -bottom-40 h-[520px] w-[520px] rounded-full bg-white/[0.04] blur-3xl" />
      </div>

      <div className="absolute left-6 top-32 hidden lg:block">
        <p className="vt-vertical-label">CYCLE 24 — Q2 / PROGRAMMING ACTIVE</p>
      </div>

      <div className="relative mx-auto grid max-w-[1380px] grid-cols-12 gap-8 px-6 pb-24 pt-20 md:px-10 lg:pb-32 lg:pt-24">
        <div className="col-span-12 lg:col-span-8">
          <div className="flex items-center gap-3">
            <span className="h-px w-12 bg-white/50" />
            <span className="vt-eyebrow text-white/65">01 — Vanta Athletic / NYC</span>
          </div>
          <h1 className="vt-display mt-8 text-[88px] text-white sm:text-[120px] md:text-[152px] lg:text-[180px]">
            TRAIN<br />
            LIKE<br />
            <span className="inline-flex items-baseline gap-6">
              NOBODY
              <span className="h-3 w-3 translate-y-[-4px] rotate-45 bg-white" />
            </span><br />
            ELSE.
          </h1>
        </div>

        <div className="col-span-12 lg:col-span-4 lg:pt-12">
          <p className="vt-eyebrow text-white/55">Programming · Coaching · Recovery</p>
          <p className="mt-4 text-[15px] leading-[1.7] text-white/75 max-w-sm">
            VANTA is a performance gym for athletes who don&apos;t do average.
            Periodised cycles, elite coaches, no fluff.
            Six floors. One standard.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <button type="button" className="vt-btn-fill">
              Start free trial
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
            </button>
            <button type="button" className="vt-btn-outline">Tour the floor</button>
          </div>
          <div className="mt-10 flex items-center gap-3">
            <div className="flex">
              {['MC', 'LO', 'DM', 'AS'].map((i, ix) => (
                <span key={i} className={'flex h-8 w-8 items-center justify-center border border-[#0A0A0A] bg-[#1A1A1A] vt-mono text-[10px] font-semibold text-white ' + (ix > 0 ? '-ml-2' : '')}>{i}</span>
              ))}
            </div>
            <p className="vt-mono text-[10px] uppercase tracking-[0.18em] text-white/55">
              Coached by 42 athletes who&apos;ve been on your side of the bar.
            </p>
          </div>
        </div>

        <div className="col-span-12 mt-16 grid grid-cols-2 gap-px border-t border-white/10 md:grid-cols-4">
          {HERO_STATS.map((s) => (
            <div key={s.label} className="border-r border-white/10 last:border-r-0 pl-1 pr-6 pt-6 first:pl-0">
              <div className="flex items-center gap-2">
                <span className="block h-[2px] w-6 origin-left bg-white vt-pulse-bar" />
                <span className="vt-eyebrow text-white/55">{s.label}</span>
              </div>
              <p className="vt-display mt-4 text-[64px] text-white">{s.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Programs.js': `import React from 'react';
import { PROGRAMS } from '../data/vanta';

export default function Programs() {
  return (
    <section id="programs" className="relative border-b border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-[1380px] px-6 py-24 md:px-10 lg:py-32">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="h-px w-12 bg-white/50" />
              <span className="vt-eyebrow text-white/65">02 — Programs</span>
            </div>
            <h2 className="vt-display mt-6 text-[68px] text-white sm:text-[88px] md:text-[112px]">
              FORGE<br />YOUR<br />DISCIPLINE.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7 lg:self-end">
            <p className="text-[15px] leading-[1.75] text-white/75 max-w-md">
              Programming built by performance coaches, not influencers.
              Each block is periodised, tested in-house, and rebuilt every cycle.
              Pick a track — we&apos;ll handle the rest.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <span className="vt-tag">All levels welcome</span>
              <span className="vt-tag">Weekly reprogramming</span>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px border-t border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-3">
          {PROGRAMS.map((p, i) => (
            <article
              key={p.code}
              className="group relative flex flex-col gap-6 bg-[#0A0A0A] p-7 transition hover:bg-[#101010]"
            >
              <div className="flex items-start justify-between">
                <span className="vt-mono text-[11px] tracking-[0.24em] text-white/45">{p.code}</span>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="text-white/40 transition group-hover:translate-x-1 group-hover:translate-y-[-2px] group-hover:text-white">
                  <path d="M7 17 17 7M9 7h8v8" />
                </svg>
              </div>

              <div className="vt-img-block relative aspect-[4/3] w-full overflow-hidden">
                <span className="vt-display absolute bottom-3 right-3 text-[120px] text-white/[0.06]">{('0' + (i + 1)).slice(-2)}</span>
                <svg viewBox="0 0 200 150" className="absolute left-6 top-6 h-14 w-14 text-white/40" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="square">
                  <path d="M30 75 L60 75 M140 75 L170 75 M75 60 L75 90 M125 60 L125 90 M75 75 L125 75" />
                </svg>
              </div>

              <div>
                <h3 className="vt-display text-[42px] text-white">{p.title}</h3>
                <p className="vt-mono mt-1 text-[10px] uppercase tracking-[0.24em] text-white/55">{p.sub}</p>
              </div>

              <p className="text-[13px] leading-[1.65] text-white/65">{p.desc}</p>

              <div className="mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-4">
                <span className="vt-tag">{p.tone}</span>
                <p className="vt-mono text-[10px] uppercase tracking-[0.22em] text-white/55">
                  {p.sessions} · {p.duration}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Trainers.js': `import React from 'react';
import { TRAINERS } from '../data/vanta';

const SIZE_CLASS = {
  tall: 'lg:row-span-2 lg:col-span-4',
  wide: 'lg:col-span-8',
  square: 'lg:col-span-4',
};
const ASPECT_CLASS = {
  tall: 'aspect-[3/4.6]',
  wide: 'aspect-[16/9]',
  square: 'aspect-[4/3]',
};

export default function Trainers() {
  return (
    <section id="coaches" className="relative border-b border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-[1380px] px-6 py-24 md:px-10 lg:py-32">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="h-px w-12 bg-white/50" />
              <span className="vt-eyebrow text-white/65">03 — Coaches</span>
            </div>
            <h2 className="vt-display mt-6 text-[68px] text-white sm:text-[88px] md:text-[112px]">
              42 ATHLETES.<br />ONE STANDARD.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="text-[15px] leading-[1.75] text-white/75">
              Coaches who have competed at the level you want to reach.
              Powerlifters, Hyrox finalists, combat athletes, mobility specialists.
              Every program is signed off by them.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-5">
          {TRAINERS.map((t) => (
            <article
              key={t.code}
              className={'group col-span-12 sm:col-span-6 ' + SIZE_CLASS[t.size]}
            >
              <div className={'vt-img-block ' + ASPECT_CLASS[t.size] + ' relative w-full overflow-hidden'}>
                <div className="absolute left-4 top-4 vt-mono text-[10px] uppercase tracking-[0.24em] text-white/65">
                  COACH / {t.code}
                </div>
                <svg viewBox="0 0 80 80" className="absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 text-white/20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
                  <circle cx="40" cy="28" r="11" />
                  <path d="M16 70 C 22 52, 58 52, 64 70" />
                </svg>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent p-5">
                  <div className="flex items-end justify-between gap-4">
                    <div>
                      <h3 className="vt-display text-[34px] text-white">{t.name}</h3>
                      <p className="vt-mono mt-1 text-[10px] uppercase tracking-[0.24em] text-white/65">{t.tag}</p>
                    </div>
                    <div className="text-right vt-mono text-[10px] uppercase tracking-[0.18em] text-white/65">
                      <p>{t.years} yrs</p>
                      <p className="mt-1">{t.athletes} athletes</p>
                    </div>
                  </div>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {t.specs.map((sp) => (
                      <span key={sp} className="vt-tag">{sp}</span>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Transformation.js': `import React from 'react';
import { PHASES } from '../data/vanta';

export default function Transformation() {
  return (
    <section className="relative border-b border-white/10 bg-[#F5F5F5] text-[#0A0A0A]">
      <div className="mx-auto max-w-[1380px] px-6 py-24 md:px-10 lg:py-32">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="h-px w-12 bg-[#0A0A0A]/50" />
              <span className="vt-eyebrow text-[#0A0A0A]/65">04 — Transformation</span>
            </div>
            <h2 className="vt-display mt-6 text-[68px] sm:text-[88px] md:text-[124px]">
              THE 90<br />DAY CYCLE.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="text-[15px] leading-[1.75] text-[#0A0A0A]/70">
              A measurable, periodised system.
              Four phases.
              Twelve weeks.
              Every cycle ends with retesting, photos, and a written program review with your coach.
            </p>
            <p className="vt-mono mt-6 text-[10px] uppercase tracking-[0.22em] text-[#0A0A0A]/55">
              · 1,840 athletes through this cycle in 2025
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-5">
          {PHASES.map((p, i) => (
            <article key={p.phase} className="col-span-12 md:col-span-6 lg:col-span-3 border border-[#0A0A0A]/15 bg-white p-7 transition hover:border-[#0A0A0A] hover:shadow-[12px_12px_0_0_#0A0A0A]">
              <div className="flex items-center justify-between">
                <span className="vt-display text-[60px] leading-none">{p.phase}</span>
                <span className="vt-tag-dark">{p.range}</span>
              </div>
              <h3 className="vt-display mt-6 text-[34px] uppercase tracking-[0.04em]">{p.name}</h3>
              <p className="mt-3 text-[13px] leading-[1.65] text-[#0A0A0A]/70">{p.detail}</p>

              <div className="mt-8">
                <div className="flex items-center justify-between vt-mono text-[10px] uppercase tracking-[0.2em] text-[#0A0A0A]/55">
                  <span>Output</span>
                  <span>{p.pulse}%</span>
                </div>
                <div className="mt-2 h-[3px] w-full bg-[#0A0A0A]/10">
                  <div style={{ width: p.pulse + '%' }} className="h-full bg-[#0A0A0A]" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Membership.js': `import React from 'react';
import { PLANS } from '../data/vanta';

export default function Membership() {
  return (
    <section id="membership" className="relative border-b border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-[1380px] px-6 py-24 md:px-10 lg:py-32">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="h-px w-12 bg-white/50" />
              <span className="vt-eyebrow text-white/65">05 — Membership</span>
            </div>
            <h2 className="vt-display mt-6 text-[68px] text-white sm:text-[88px] md:text-[112px]">
              CHOOSE YOUR<br />INTENSITY.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="text-[15px] leading-[1.75] text-white/75">
              Pause or upgrade any time.
              No hidden initiation.
              No 12-month contracts.
              Just programming priced honestly.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-5">
          {PLANS.map((plan) => {
            const isFeat = plan.featured;
            return (
              <article
                key={plan.name}
                className={
                  'col-span-12 lg:col-span-4 flex flex-col p-8 transition ' +
                  (isFeat
                    ? 'bg-[#F5F5F5] text-[#0A0A0A] hover:bg-white'
                    : 'border border-white/15 bg-[#0A0A0A] text-white hover:border-white/45 hover:translate-y-[-4px]')
                }
              >
                <div className="flex items-center justify-between">
                  <p className="vt-display text-[40px]">{plan.name}</p>
                  {isFeat && <span className="vt-mono text-[10px] uppercase tracking-[0.22em] px-2 py-1 border border-[#0A0A0A]">Most picked</span>}
                </div>

                <div className="mt-6 flex items-baseline gap-2">
                  <span className="vt-display text-[80px] leading-none">{plan.price}</span>
                  <span className="vt-mono text-[12px] uppercase tracking-[0.2em] opacity-65">{plan.period}</span>
                </div>

                <p className={'mt-5 text-[13px] leading-[1.65] ' + (isFeat ? 'text-[#0A0A0A]/70' : 'text-white/70')}>{plan.desc}</p>

                <ul className="mt-7 space-y-3 text-[13px]">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-3">
                      <span className={'mt-2 h-[2px] w-4 ' + (isFeat ? 'bg-[#0A0A0A]' : 'bg-white')} />
                      <span className={isFeat ? 'text-[#0A0A0A]/80' : 'text-white/80'}>{f}</span>
                    </li>
                  ))}
                </ul>

                <button
                  type="button"
                  className={'mt-9 w-full justify-center ' + (isFeat ? 'vt-btn-invert' : 'vt-btn-fill')}
                >
                  {plan.cta}
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Testimonials.js': `import React from 'react';
import { TESTIMONIALS } from '../data/vanta';

export default function Testimonials() {
  return (
    <section className="relative border-b border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-[1380px] px-6 py-24 md:px-10 lg:py-32">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="h-px w-12 bg-white/50" />
              <span className="vt-eyebrow text-white/65">06 — Voices of VANTA</span>
            </div>
            <h2 className="vt-display mt-6 text-[68px] text-white sm:text-[88px] md:text-[112px]">
              REAL ATHLETES.<br />REAL OUTPUT.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="vt-mono text-[10px] uppercase tracking-[0.22em] text-white/55">
              · Verified members · 4.94 / 5 average · 1,200+ reviews
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-12 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              className={
                'col-span-12 md:col-span-6 lg:col-span-4 border border-white/12 bg-[#0A0A0A] p-7 transition hover:border-white/35 ' +
                (i === 1 ? 'lg:translate-y-8' : '')
              }
            >
              <svg width="34" height="26" viewBox="0 0 32 24" fill="none" className="text-white/80">
                <path d="M0 24V14C0 6 5 0 13 0V4C8 4 6 7 6 10H13V24H0ZM19 24V14C19 6 24 0 32 0V4C27 4 25 7 25 10H32V24H19Z" fill="currentColor" />
              </svg>

              <p className="vt-display mt-6 text-[26px] uppercase leading-[1.15] tracking-[0.005em] text-white">
                {t.quote}
              </p>

              <div className="mt-8 flex items-center justify-between">
                <div>
                  <p className="vt-mono text-[12px] uppercase tracking-[0.16em] text-white">{t.name}</p>
                  <p className="vt-mono mt-1 text-[10px] uppercase tracking-[0.2em] text-white/55">{t.meta}</p>
                </div>
                <div className="flex items-center gap-1">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <span key={s} className="block h-[2px] w-3 bg-white" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Gallery.js': `import React from 'react';
import { GALLERY } from '../data/vanta';

const SIZE_CLASS = {
  tall: 'lg:row-span-2 lg:col-span-4 aspect-[3/4.6]',
  wide: 'lg:col-span-8 aspect-[16/9]',
  square: 'lg:col-span-4 aspect-[4/3]',
};

export default function Gallery() {
  return (
    <section className="relative border-b border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-[1380px] px-6 py-24 md:px-10 lg:py-32">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="h-px w-12 bg-white/50" />
              <span className="vt-eyebrow text-white/65">07 — Inside the floor</span>
            </div>
            <h2 className="vt-display mt-6 text-[68px] text-white sm:text-[88px] md:text-[112px]">
              SIX FLOORS.<br />ONE TEMPLE.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="text-[15px] leading-[1.75] text-white/75">
              From olympic platforms to a 4-ring combat floor, recovery suites, mobility lab and a cardio deck overlooking the city — VANTA is built for serious training.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-12 gap-5">
          {GALLERY.map((g) => (
            <article key={g.code} className={'group col-span-12 sm:col-span-6 ' + SIZE_CLASS[g.size]}>
              <div className="vt-img-block relative h-full w-full overflow-hidden">
                <div className="absolute left-4 top-4 vt-mono text-[10px] uppercase tracking-[0.22em] text-white/55">
                  {g.code}
                </div>
                <svg viewBox="0 0 120 120" className="absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 text-white/18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="square">
                  <path d="M20 60h80M60 20v80M28 28l64 64M92 28L28 92" />
                </svg>
                <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-[#0A0A0A] to-transparent px-5 py-4">
                  <p className="vt-mono text-[11px] uppercase tracking-[0.22em] text-white">{g.label}</p>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="square" className="text-white/55 transition group-hover:translate-x-1 group-hover:text-white">
                    <path d="M7 17 17 7M9 7h8v8" />
                  </svg>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/CTABanner.js': `import React from 'react';

export default function CTABanner() {
  return (
    <section className="relative overflow-hidden border-b border-white/10 bg-[#0A0A0A]">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[640px] w-[640px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/[0.04] blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-[1380px] px-6 py-28 md:px-10 lg:py-40">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-2">
            <p className="vt-eyebrow text-white/55">08 — Final call</p>
            <span className="vt-display mt-6 block text-[80px] text-white/15">/24</span>
          </div>

          <div className="col-span-12 lg:col-span-8 text-center">
            <h2 className="vt-display text-[88px] text-white sm:text-[140px] md:text-[200px] leading-[0.88]">
              STOP<br />WAITING.<br />
              <span className="inline-flex items-baseline gap-6">
                START
                <span className="hidden md:inline-block h-4 w-4 translate-y-[-6px] rotate-45 bg-white" />
              </span><br />LIFTING.
            </h2>
            <div className="mt-12 flex flex-wrap justify-center gap-3">
              <button type="button" className="vt-btn-fill">
                Start 7-day trial
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
              </button>
              <button type="button" className="vt-btn-outline">Book a tour</button>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-2 lg:text-right">
            <p className="vt-mono text-[10px] uppercase tracking-[0.22em] text-white/55">
              First session free. No card required.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
`,

  'src/components/Footer.js': `import React from 'react';
import { FOOTER_COLS, NAV_LINKS } from '../data/vanta';

export default function Footer() {
  return (
    <footer className="relative bg-[#0A0A0A] text-white">
      <div className="mx-auto max-w-[1380px] px-6 py-20 md:px-10">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-6">
            <p className="vt-display text-[120px] leading-[0.88] sm:text-[180px] md:text-[220px] text-white">VANTA</p>
            <p className="vt-mono mt-4 text-[10px] uppercase tracking-[0.32em] text-white/55">Athletic · Est 2018 · NYC + LA + LDN</p>
            <p className="mt-8 max-w-md text-[14px] leading-[1.7] text-white/70">
              Performance gym, built by athletes for athletes.
              Six floors of training across three cities. Programming periodised in 12-week cycles.
            </p>
          </div>

          {FOOTER_COLS.map((col) => (
            <div key={col.title} className="col-span-6 sm:col-span-4 lg:col-span-2">
              <p className="vt-mono text-[10px] uppercase tracking-[0.28em] text-white/55">{col.title}</p>
              <ul className="mt-6 space-y-3 text-[13px]">
                {col.links.map((l) => (
                  <li key={l}><a href={'#' + l.toLowerCase().replace(/\\s/g, '-')} className="text-white/80 transition hover:text-white">{l}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 vt-divider" />

        <div className="mt-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 vt-mono text-[10px] uppercase tracking-[0.22em] text-white/55">
            <span>© 2026 VANTA Athletic</span>
            <span>·</span>
            <a href="#privacy" className="hover:text-white">Privacy</a>
            <a href="#terms" className="hover:text-white">Terms</a>
            <a href="#waiver" className="hover:text-white">Member waiver</a>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            {NAV_LINKS.slice(0, 3).map((l) => (
              <a key={l.href} href={l.href} className="vt-mono text-[10px] uppercase tracking-[0.22em] text-white/55 hover:text-white">{l.label}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
`,
};
